var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tasks-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var campaign = ref.campaign;
var proposal = ref.proposal;
var proposalStep = ref.proposalStep;
var patchProposalStep = ref.patchProposalStep;
var goNextStep = ref.goNextStep;
var goPreviousStep = ref.goPreviousStep;
var isLoading = ref.isLoading;
var isCompletingProposal = ref.isCompletingProposal;
var errors = ref.errors;
var errorMessage = ref.errorMessage;
return [_c('proposal-tasks-view',{attrs:{"campaign":campaign,"proposal-step":proposalStep,"proposal":proposal,"is-loading":isLoading,"errors":errors,"error-message":errorMessage,"is-completing-proposal":isCompletingProposal},on:{"go-next-step":goNextStep,"go-previous-step":goPreviousStep,"patch-step":patchProposalStep}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }